import { Component, OnInit } from '@angular/core';
import {GoBaseComponent} from "../go-base.component";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";

@Component({
  selector: 'go-render',
  templateUrl: './go-render.component.html',
  styles: []
})
export class GoRenderComponent extends GoBaseComponent {

  GO_COMPONENTS = GO_COMPONENTS;
  constructor() {
    super(GO_COMPONENTS.RENDER);
  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-render/go-render.component.ts